import { CheckboxStyledFRDS } from './CheckboxStyledFR-DS';
import styled from 'styled-components';

export const CheckboxStyledUKDS = styled(CheckboxStyledFRDS)``;
